import { EntityService } from "@/model/service/entity-service"
import { CutOffTime } from "@/model/entity/cut-off-time/cut-off-time"
import { AxiosPromise } from "axios"
import { plainToClass } from "class-transformer"
import { Filter } from "@/model/dto/filter"
import { DatatableSort } from "@/model/dto/datatable-sort"
import { Page } from "@/model/dto/page"

class CutOffTimeService extends EntityService<CutOffTime> {
  constructor() {
    super("cut_off_time", CutOffTime)
  }

  getPage(page: number, rows: number, filters: Filter[], sort?: DatatableSort): AxiosPromise<Page<any>> {
    return this.$http.get(this.path + this.buildQueryParams(filters, page - 1, rows, sort)).then(response => {
      response.data.content = plainToClass(this.classType, response.data.content)
      return response
    })
  }

  findCutOffTimeById(id: number): AxiosPromise<CutOffTime> {
    return this.$http.get(this.path + "/" + id).then(response => {
      response.data = plainToClass(this.classType, response.data)
      return response
    })
  }

  saveCutOffTime(entity: CutOffTime): AxiosPromise<CutOffTime> {
    return super.create(entity).then(response => {
      return response
    })
  }

  updateCutOffTime(entity: CutOffTime): AxiosPromise<CutOffTime> {
    return super.modify(entity).then(response => {
      return response
    })
  }

  deleteCutOffTime(id: number): AxiosPromise<void> {
    return this.$http.delete(this.path + "/" + id)
  }
}

export interface ICutOffTimeService extends EntityService<CutOffTime> {}

const service = new CutOffTimeService()

export const cutOffTimeService = service
